import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "question-circle",
  "use": "question-circle-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"question-circle\">\n  <path fill-rule=\"evenodd\" d=\"M375,387a9,9,0,1,1,9-9A9,9,0,0,1,375,387Zm0-16.313A7.313,7.313,0,1,0,382.313,378,7.321,7.321,0,0,0,375,370.687Z\" transform=\"translate(-366 -369)\" />\n  <path fill-rule=\"evenodd\" d=\"M373.91,379.173h1.8c-0.12-1.32,1.631-1.7,1.631-3.143,0-1.511-1.055-2.111-2.374-2.111a3.149,3.149,0,0,0-2.375,1.128l1.127,1.031a1.411,1.411,0,0,1,.984-0.5,0.585,0.585,0,0,1,.671.6C375.373,376.942,373.67,377.613,373.91,379.173Zm0.888,3.07A1.248,1.248,0,1,0,373.6,381,1.2,1.2,0,0,0,374.8,382.243Z\" transform=\"translate(-366 -369)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/question-circle.svg
// module id = null
// module chunks = 